import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import {
  getAccountDetails,
  stripIllegalCharacters,
  amountWithinLimit,
} from '../../businessLogic/AccountsBL';
import {
  getTransactionAccountData,
  isButtonDisabled,
  showAmountValidationError,
} from '../../businessLogic/AlertsBL';
import TransactionAlertComponent from '../../components/TransactionAlertComponent';
import { getTransactionMethods, isTransactionMethodEnabled } from '../../utils/TransactionMethods';
import { isLoading, getBrandId, isSMEAlertEnable } from '../../infrastructure/config/selectors';
import {
  getTransactionToggleRequestPacket,
  getTransactionMethodOFF,
} from '../../utils/RequestPacketBuilder';
import { FIX_DECIMAL_BY_TWO } from '../../constants/StringConstants';
import { fixAmount } from '../../utils/NumberUtils';
import {
  CB_TRANSACTION_ABROAD_URL,
  YB_TRANSACTION_ABROAD_URL,
  B_TRANSACTION_ABROAD_URL,
  VM_TRANSACTION_ABROAD_URL,
} from '../../constants/urls';
import { CommonModal } from '../../components/common/CommonModal';

export class TransactionAlertsLandingPage extends Component {
  // eslint-disable-next-line max-statements
  constructor(props) {
    super(props);
    const {
      amountTransactionAlerts: {
        amount: { value: transactionAmount },
      },
    } = props;
    this.state = {
      transactionAmount: transactionAmount.toFixed(FIX_DECIMAL_BY_TWO),
      showTransactionMethods: isTransactionMethodEnabled(props.transactionAlertMethods),
    };
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleTransactionBalRequestPacket = this.handleTransactionBalRequestPacket.bind(this);
    this.handleTransactionToggleRequestPacket =
      this.handleTransactionToggleRequestPacket.bind(this);
    this.cancelAlertChanges = this.cancelAlertChanges.bind(this);
    this.toggleTransactionMethodOn = this.toggleTransactionMethodOn.bind(this);
    this.handleTransactionMethodChange = this.handleTransactionMethodChange.bind(this);
    this.backClick = this.backClick.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.getAbroadURL = this.getAbroadURL.bind(this);
    this.retryRequest = this.retryRequest.bind(this);
    this.backClick = this.backClick.bind(this);
    this.closeUpdateModal = this.closeUpdateModal.bind(this);
    this.showTransactionMethodMasterPopup = this.showTransactionMethodMasterPopup.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { transactionAlertMethods, masterCardLeavePopup, isEditModeEnabled } = this.props;
    const { showTransactionMethods } = this.state;
    const isMethodsEnabled = isTransactionMethodEnabled(transactionAlertMethods);
    if (isMethodsEnabled !== showTransactionMethods) {
      this.setState({ showTransactionMethods: isMethodsEnabled });
    }
    if (masterCardLeavePopup && prevProps.isEditModeEnabled !== isEditModeEnabled) {
      masterCardLeavePopup(isEditModeEnabled);
    }
  }
  componentWillUnmount() {
    const { masterCardLeavePopup, showTransactionAmountError, showButton, editModeEnabled } =
      this.props;
    if (masterCardLeavePopup) {
      masterCardLeavePopup(false);
    }
    editModeEnabled(false);
    showTransactionAmountError(false);
    showButton(false);
  }
  handleAmountChange(event) {
    const { showButton, showTransactionAmountError, amountTransactionAlerts, editModeEnabled } =
      this.props;
    const {
      amount: { value: transactionAmount },
    } = amountTransactionAlerts;
    const amount = stripIllegalCharacters(event.target.value);
    if (amount) {
      editModeEnabled(true);
    }
    showButton(isButtonDisabled(amount, transactionAmount));
    showTransactionAmountError(showAmountValidationError(amount));
    if (amountWithinLimit(amount)) {
      this.setState({ transactionAmount: amount });
    }
  }
  handleOnBlur(event) {
    const {
      showButton,
      amountTransactionAlerts: {
        amount: { value: transactionAmount },
      },
    } = this.props;
    const amount = fixAmount(event.target.value);
    this.setState({ transactionAmount: amount });
    showButton(isButtonDisabled(amount, transactionAmount));
  }
  handleTransactionBalRequestPacket(transactionRequestPacket, alertType) {
    const {
      updateTransactionAlerts,
      accountDetails,
      amountTransactionAlerts,
      editModeEnabled,
      showTransactionAmountError,
    } = this.props;
    updateTransactionAlerts(transactionRequestPacket, accountDetails.id);
    alertType === 'toggle' &&
      this.setState({
        transactionAmount: amountTransactionAlerts.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
      });
    editModeEnabled(false);
    showTransactionAmountError(false);
  }
  handleTransactionToggleRequestPacket(abroadRequestPacket) {
    const { updateTransactionAlerts, accountDetails, amountTransactionAlerts } = this.props;
    this.setState({
      transactionAmount: amountTransactionAlerts.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
    });
    updateTransactionAlerts(abroadRequestPacket, accountDetails.id);
  }
  cancelAlertChanges() {
    const { amountTransactionAlerts, showButton, editModeEnabled } = this.props;
    this.setState({
      transactionAmount: amountTransactionAlerts.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
    });
    showButton(false);
    editModeEnabled(false);
  }
  toggleTransactionMethodOn() {
    const { accountDetails, updateTransactionAlerts, showMethodAlertsMasterPopup } = this.props;
    updateTransactionAlerts(getTransactionToggleRequestPacket('internet', true), accountDetails.id);
    showMethodAlertsMasterPopup(false);
  }
  showTransactionMethodMasterPopup(toggleValue) {
    const { showMethodAlertsMasterPopup, updateTransactionAlerts, accountDetails } = this.props;
    if (toggleValue) {
      showMethodAlertsMasterPopup(toggleValue);
    } else {
      updateTransactionAlerts(getTransactionMethodOFF(toggleValue), accountDetails.id);
    }
  }
  handleTransactionMethodChange(id, enabled) {
    const { accountDetails, updateTransactionAlerts } = this.props;
    updateTransactionAlerts(getTransactionToggleRequestPacket(id, enabled), accountDetails.id);
  }
  backClick() {
    const { routeTo, isEditModeEnabled, showUnsavedLeavePopup, isSMEAlertEnable } = this.props;
    if (isEditModeEnabled) {
      showUnsavedLeavePopup(true);
    } else isSMEAlertEnable ? routeTo('/transactions') : routeTo('/singlealerts');
  }
  getAbroadURL() {
    const { brandID } = this.props;
    switch (brandID) {
      case 'CB':
        return CB_TRANSACTION_ABROAD_URL;
      case 'YB':
        return YB_TRANSACTION_ABROAD_URL;
      case 'VM':
        return VM_TRANSACTION_ABROAD_URL;
      default:
        return B_TRANSACTION_ABROAD_URL;
    }
  }
  retryRequest() {
    const { updateTransactionAlerts, transactionRequestPacket, accountDetails, closePopup } =
      this.props;
    closePopup(false);
    updateTransactionAlerts(transactionRequestPacket, accountDetails.id);
  }
  closeUpdateModal() {
    const { showUnsavedLeavePopup, routeTo, isSMEAlertEnable } = this.props;
    showUnsavedLeavePopup(false);
    isSMEAlertEnable ? routeTo('/transactions') : routeTo('/singlealerts');
  }
  render() {
    const {
      accountDetails,
      content,
      abroadTransactionAlerts,
      amountTransactionAlerts,
      userPhoneNumber,
      showAmountButton,
      isLoading,
      transactionAlertMethods,
      transactionError,
      closePopup,
      showButton,
      transactionAmountValidation,
      showAbroadPopup,
      isAbroadPopupEnabled,
      closeAbroadPopup,
      isLeavePopupEnable,
      showUnsavedLeavePopup,
      showMethodPopup,
      showMethodAlertsMasterPopup,
    } = this.props;
    const { transactionAmount, showTransactionMethods } = this.state;
    return (
      <div>
        <TransactionAlertComponent
          backClick={this.backClick}
          accountDetails={accountDetails}
          content={content}
          transactionAmount={transactionAmount}
          handleAmountChange={this.handleAmountChange}
          handleOnBlur={this.handleOnBlur}
          toggleList={transactionAlertMethods}
          handleTransactionBalRequestPacket={this.handleTransactionBalRequestPacket}
          handleTransactionToggleRequestPacket={this.handleTransactionToggleRequestPacket}
          abroadTransactionAlerts={abroadTransactionAlerts.enabled}
          amountTransactionAlerts={amountTransactionAlerts}
          userPhoneNumber={userPhoneNumber}
          showButton={(buttonState) => {
            showButton(buttonState);
          }}
          cancelAlertChanges={this.cancelAlertChanges}
          showAmountButton={showAmountButton}
          isLoading={isLoading}
          showTransactionMethods={showTransactionMethods}
          toggleTransactionMethod={this.showTransactionMethodMasterPopup}
          handleTransactionMethodChange={this.handleTransactionMethodChange}
          transactionError={transactionError}
          closePopup={() => {
            closePopup(false);
          }}
          retryRequest={this.retryRequest}
          isAmountValid={transactionAmountValidation}
          getAbroadURL={this.getAbroadURL}
          showAbroadPopup={() => {
            showAbroadPopup(true);
          }}
          isAbroadPopupEnabled={isAbroadPopupEnabled}
          closeAbroadPopup={() => {
            closeAbroadPopup(false);
          }}
        />
        {isLeavePopupEnable && (
          <CommonModal
            isOpen={isLeavePopupEnable}
            onRequestClose={this.closeUpdateModal}
            onPrimaryBtnClick={() => {
              showUnsavedLeavePopup(false);
            }}
            header={content.leavePopupHeader}
            infoCardContent={content.leavePopupContent}
            primaryBtnName={content.leavePopupPrimaryBtnName}
            secondaryBtnName={content.leavePopupSecondaryBtnName}
          />
        )}
        {showMethodPopup && (
          <CommonModal
            isOpen={showMethodPopup}
            showSecondaryButton={false}
            onRequestClose={() => {
              showMethodAlertsMasterPopup(false);
            }}
            onPrimaryBtnClick={this.toggleTransactionMethodOn}
            header={content.confirmMethodPopupHeader}
            infoCardContent={content.confirmMethodPopupContent}
            primaryBtnName={content.confirmMethodPopupBtnName}
          />
        )}
      </div>
    );
  }
}
TransactionAlertsLandingPage.propTypes = {
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({}),
  backClick: PropTypes.func,
  updateTransactionAlerts: PropTypes.func,
  routeTo: PropTypes.func,
  abroadTransactionAlerts: PropTypes.shape({}),
  amountTransactionAlerts: PropTypes.shape({
    amount: PropTypes.shape({
      value: PropTypes.number,
    }),
  }),
  userPhoneNumber: PropTypes.array,
  showButton: PropTypes.func,
  showAmountButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  transactionAlertMethods: PropTypes.array,
  transactionError: PropTypes.bool,
  closePopup: PropTypes.func,
  userSegment: PropTypes.string,
  userSubSegment: PropTypes.string,
  showTransactionAmountError: PropTypes.func,
  transactionAmountValidation: PropTypes.bool,
  brandID: PropTypes.string,
  showAbroadPopup: PropTypes.func,
  isAbroadPopupEnabled: PropTypes.bool,
  closeAbroadPopup: PropTypes.func,
  transactionRequestPacket: PropTypes.array,
  masterCardLeavePopup: PropTypes.func,
  editModeEnabled: PropTypes.func,
  isEditModeEnabled: PropTypes.bool,
  isLeavePopupEnable: PropTypes.bool,
  showUnsavedLeavePopup: PropTypes.func,
  showMethodAlertsMasterPopup: PropTypes.func,
  showMethodPopup: PropTypes.bool,
  isSMEAlertEnable: PropTypes.bool,
};
const mapStateToProps = (state) => {
  const { accountList, bulkTransactionAlerts, userDetails, loader, validation, config } = state;
  const accountId = accountList.get('selectedAccountId');
  const transactionAlerts = bulkTransactionAlerts.get('bulkTransactionAlerts').debit_alert;
  return {
    accountDetails: getAccountDetails(accountId, accountList.get('accountList').accounts),
    transactionAlertMethods: getTransactionMethods(
      bulkTransactionAlerts.get('bulkTransactionAlerts')
    ),
    amountTransactionAlerts: getTransactionAccountData(transactionAlerts, 'amount'),
    abroadTransactionAlerts: getTransactionAccountData(transactionAlerts, 'crossborder'),
    userPhoneNumber: userDetails.get('userDetails').phone_numbers,
    showAmountButton: bulkTransactionAlerts.get('showButton'),
    isLoading: isLoading(loader),
    transactionError: bulkTransactionAlerts.get('transactionError'),
    transactionAmountValidation: validation.get('transactionAmountValidation'),
    brandID: getBrandId(config),
    isAbroadPopupEnabled: bulkTransactionAlerts.get('showAbroadPopup'),
    transactionRequestPacket: bulkTransactionAlerts.get('transactionRequestPacket'),
    isEditModeEnabled: validation.get('enableEditMode'),
    isLeavePopupEnable: validation.get('enableUnsavedLeavePopup'),
    showMethodPopup: bulkTransactionAlerts.get('showMethodAlertsMasterPopup'),
    isSMEAlertEnable: isSMEAlertEnable(state),
  };
};
const mapDispatch = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatch)(TransactionAlertsLandingPage);
